import { getImagePlacement } from '../utils/imagePlacement';

import type Phaser from 'phaser';
import type { ImagePivot, RelativeImageOffset } from '../../types';
import type { Point } from './StrokeEvaluator';

type GoalConfig = {
	scene: Phaser.Scene;
	parent: Phaser.GameObjects.Container;
	x: number;
	y: number;
	direction: Point;
	textureKey: string;
	pivot?: ImagePivot;
	strokeOffset?: RelativeImageOffset;
};

export class Goal {
	readonly image: Phaser.GameObjects.Image;

	constructor({ scene, parent, x, y, direction, textureKey, pivot = [0.5, 0.5], strokeOffset }: GoalConfig) {
		this.image = scene.add.image(0, 0, textureKey).setOrigin(...pivot);
		const position = getImagePlacement({ x, y }, direction, this.image, 1, strokeOffset);
		this.image.setPosition(position.x, position.y);
		parent.add(this.image);
	}
}
